import { DbTimestampGenerated, DbTimestampNullable } from '@harvestiq/utils';
import { zTimestamp } from '@harvestiq/zod';
import { expectTypeOf } from 'expect-type';
import { Insertable, Selectable, Updateable } from 'kysely';
import { z } from '@harvestiq/zod';

export interface RolesTable {
  id: string;
  title: string;
  description: string | null;
  capabilities: string[] | null;
  createdAt: DbTimestampGenerated;
  updatedAt: DbTimestampGenerated;
  deletedAt: DbTimestampNullable;
}

export type DbRole = Selectable<RolesTable>;
export type DbRoleInsert = Insertable<RolesTable>;
export type DbRoleUpdate = Updateable<RolesTable>;

export const dbRoleSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  capabilities: z.array(z.string()).nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullable(),
});
expectTypeOf<DbRole>().toMatchTypeOf<z.output<typeof dbRoleSchema>>();

export const dbRoleInsertSchema = dbRoleSchema
  .omit({
    id: true,
  })
  .partial()
  .extend({
    id: z.string(),
    title: z.string(),
    createdAt: zTimestamp().optional(),
    updatedAt: zTimestamp().optional(),
    deletedAt: zTimestamp().nullable().optional(),
  });
type CreateRoleFromSchema = z.input<typeof dbRoleInsertSchema>;
expectTypeOf<keyof CreateRoleFromSchema>().toEqualTypeOf<keyof DbRoleInsert>();
expectTypeOf<CreateRoleFromSchema>().toMatchTypeOf<DbRoleInsert>();

export const dbRoleUpdateSchema = dbRoleInsertSchema.partial();
type UpdateRoleFromSchema = z.input<typeof dbRoleUpdateSchema>;
expectTypeOf<keyof UpdateRoleFromSchema>().toEqualTypeOf<keyof DbRoleUpdate>();
expectTypeOf<UpdateRoleFromSchema>().toMatchTypeOf<DbRoleUpdate>();
